import { Tag, Typography } from 'antd'
import React from 'react'
import styles from './registryMatches.module.scss'

const { Paragraph } = Typography

const ellipsisConfig = {
  rows: 2,
  expandable: 'collapsible' as const,
  symbol: (expanded: boolean) => <span className={styles.showMore}>{expanded ? 'show less' : 'show more'}</span>,
}

export const columns = [
  {
    key: 'businessNames',
    title: 'Business Name',
    dataIndex: 'businessNames',
    width: 180,
    render: (names: string[]) => (
      <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{names.length > 0 ? names.join(', ') : 'N/A'}</div>
    ),
  },
  {
    key: 'dba',
    title: 'DBA',
    dataIndex: 'dba',
    width: 150,
    render: (dba: string) => <span>{dba}</span>,
  },
  {
    key: 'addresses',
    title: 'Address',
    dataIndex: 'addresses',
    width: 350,
    render: (addresses: string[] | undefined) => {
      const text = addresses && addresses.length > 0 ? addresses.join(', ') : 'N/A'
      return (
        <Paragraph ellipsis={ellipsisConfig} style={{ marginBottom: 0 }}>
          {text}
        </Paragraph>
      )
    },
  },
  {
    key: 'regId',
    title: 'Registration ID',
    dataIndex: 'regId',
    width: 180,
    render: (regIds: { key: string; value: string }[]) => {
      const text = regIds.map(r => r.value).join(', ')
      return (
        <Paragraph ellipsis={ellipsisConfig} style={{ marginBottom: 0 }}>
          {text}
        </Paragraph>
      )
    },
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    width: 100,
    render: (status: 'Active' | 'Inactive') => (
      <Tag className={status === 'Active' ? styles.activeStatus : styles.inactiveStatus}>{status}</Tag>
    ),
  },
  {
    key: 'dateRange',
    title: 'Date Range',
    dataIndex: 'dateRange',
    width: 150,
    render: (dateRange: string) => (
      <div className={styles.dateRange} style={{ whiteSpace: 'normal' }}>
        {dateRange}
      </div>
    ),
  },
]
